import {decorate, observable, action} from 'mobx';
import EditStore from './editStore'

class CustomerStore extends EditStore {
    generalInformationDuringEdit = false
    accessEditable = false
    customerDuringSave = false;
    dirty = false

    setDirty(value) {
        this.dirty = value
    };

    setDuringSave = value => this.customerDuringSave = value;

    canSave = () => !(this.accessEditable || this.generalInformationDuringEdit || this.customerDuringSave);
    canDelete = () => !this.isNew() && this.formModel.canDelete;
}

decorate(CustomerStore, {
    generalInformationDuringEdit: observable,
    accessEditable: observable,
    dirty: observable,

    setDirty: action
})

const customerStore = new CustomerStore();
export default customerStore;